module.exports = __webpack_public_path__ + "static/img/VDF.2c765583.png";